import { useTranslation } from 'react-i18next'

import { UseTooltips } from './types'

export const useTooltips = (): UseTooltips => {
  const { t } = useTranslation(['features/domain', 'common'])

  return {
    adHolding: {
      content: t('form.viewabilityTools.basicSettings.adHolding.tooltip'),
      link: {
        title: t('common:learnMore'),
        url: 'https://knowledge-base.yieldbird.com/viewability-tools/ad-holding',
      },
    },
    excludeCreativeTypesEnabled: {
      content: t(
        'form.viewabilityTools.basicSettings.adHolding.excludeCreativeTypesEnabled.tooltip',
      ),
    },
    gamAdRenderMargin: {
      content: t(
        'form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.gamAdRenderMargin.tooltip',
      ),
    },
    gamAdRequestMargin: {
      content: t(
        'form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.gamAdRequestMargin.tooltip',
      ),
    },
    kvTargetingAndPrebidAuction: {
      content: t(
        'form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.kvTargetingAndPrebidAuction.tooltip',
      ),
    },
    lazyLoading: {
      content: t('form.viewabilityTools.basicSettings.lazyLoadingEnabled.tooltip'),
      link: {
        title: t('common:learnMore'),
        url: 'https://knowledge-base.yieldbird.com/viewability-tools/lazy-loading',
      },
    },
    lazyLoadTargetingPrebidAuctionEnabled: {
      content: t(
        'form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.lazyLoadTargetingPrebidAuctionEnabled.tooltip',
      ),
    },
    mobileScaling: {
      content: t(
        'form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.mobileScaling.tooltip',
      ),
    },

    scrollSlownig: {
      content: t('form.viewabilityTools.basicSettings.scrollSlowingEnabled.tooltip'),
      link: {
        title: t('common:learnMore'),
        url: 'https://knowledge-base.yieldbird.com/viewability-tools/scroll-slowing',
      },
    },
  } as const
}
